import { Controller } from '@hotwired/stimulus'

// This class is used to register action on image click
// On the click of an image we want to display it in full size with a lightbox
export default class extends Controller {

  static targets = ['images']
  private classesToObserve = ['kg-gallery-image', 'full-image', 'kg-image-card']

  declare imagesTarget: HTMLElement

  connect() {
    const instance = this

    const el = this.imagesTarget
    const elementsToObserve = this.getElementsToObserve(el)

    elementsToObserve.forEach((el: HTMLElement) => {
      let img = el.querySelector('img')
      if (el.tagName !== 'IMG') {
        img = el.querySelector('img')
      }

      let imageSource = img.getAttribute('src')

      el.classList.add('cursor-pointer')
      el.addEventListener('click', () => {
        el.insertAdjacentHTML('afterend', instance.lightbox(imageSource))
      })


    })
  }

  private getElementsToObserve(el: HTMLElement) {
    return this.classesToObserve.reduce((prev, className) => {
      el.querySelectorAll(`.${className}`).forEach((img: HTMLElement) => {
        prev.push(img)
      })

      return prev
    }, [] as HTMLElement[])
  }

  lightbox(src: string) {
    const instance = this
    return `<div
        data-controller="lightbox"
        data-lightbox-target="lightbox"
        data-action="keydown.esc@window->lightbox#deleteLightbox"
        style="z-index: 1000"
        class="target:block fixed inset-0 p-10 bg-black/75 overflow-auto">
        
    <div href="javascript:void(0)"
         class="px-4 py-4 text-white absolute right-0 top-0 cursor-pointer"
         data-action="click->lightbox#deleteLightbox">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd"
                  d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd"/>
        </svg>
    </div>
    <div class="flex justify-center w-full h-full">
        <img
                class="object-contain max-h-full max-w-full"
                src="${src}"
                alt="full size image"
        />
    </div>
</div>
    `
  }

  deleteLightbox() {
    this.imagesTarget.querySelector('#lightbox').remove()
  }
}

export class LightboxController extends Controller {
  static targets = ['lightbox']

  declare lightboxTarget: HTMLElement

  connect() {
    console.log('connected')
  }

  deleteLightbox() {
    this.lightboxTarget.remove()
  }
}
